import { observer } from 'mobx-react-lite'
import { type JobSearchViewModel } from '@/features/jobs/list/JobSearchViewModel'
import { JobFilterViewHeading } from '@/features/jobs/list/components/JobFilterViewHeading'

export interface JobFilterViewHeadingContainerProps {
  vm: JobSearchViewModel
}

export const JobFilterViewHeadingContainer = observer(
  function JobFilterViewHeadingContainer({
    vm,
  }: JobFilterViewHeadingContainerProps) {
    return (
      <JobFilterViewHeading
        showSearchScopeFilter={vm.showSearchScopeFilter}
        scope={vm.scope}
        jobPeriodOption={vm.jobPeriodOption}
        onScopeChange={vm.setScope}
        onJobPeriodChange={vm.setJobPeriod}
      />
    )
  },
)
